import type { Category } from "@/types/content";

export const categories: Category[] = [
  {
    id: "轿车",
    name: "轿车",
    desc: "覆盖紧凑型到中大型轿车的上市、改款与市场表现。",
    icon: "ri-car-line",
    intro: "轿车作为最经典的品类，兼顾家用与商务场景。这里汇总各级别轿车的最新动态、产品解析与市场走向。",
  },
  {
    id: "SUV",
    name: "SUV",
    desc: "城市 SUV、硬派越野与大空间家用车型的资讯集合。",
    icon: "ri-roadster-line",
    intro: "SUV 是国内增长最快的细分市场之一。从城市通勤到家庭出行，从轻越野到硬派越野，这里覆盖主流车型的更新与对比。",
  },
  {
    id: "新能源车",
    name: "新能源车",
    desc: "纯电、插混与增程车型的技术、补能与销量追踪。",
    icon: "ri-flashlight-fill",
    intro: "新能源车正在重塑汽车产业。这里聚焦三电技术、补能体系、智能驾驶与销量数据，帮你把握电动化浪潮。",
  },
  {
    id: "性能跑车",
    name: "性能跑车",
    desc: "高性能跑车、性能轿车与赛道取向车型的报道。",
    icon: "ri-speed-up-line",
    intro: "性能车代表着品牌的技术上限。这里记录跑车与性能轿车的换代、动力升级和赛道表现。",
  },
];

export const industryCategory: Category = {
  id: "行业",
  name: "行业动态",
  desc: "政策、市场、技术与产业链的深度观察。",
  icon: "ri-building-2-line",
  intro: "从政策法规到产销数据，从供应链到出海布局，行业动态帮助你理解汽车产业背后的趋势与逻辑。",
};